const Label = (props) => <span className={props.className}>{props.children}</span>;

export default Label;
